export default {
  canEndInspections: [],
  canEndInspection: undefined,
};
